export const CLASSPREFIX = 'muze';
export const CONSOLIDATED = 'consolidated';
export const FRAGMENTED = 'fragmented';
export const NULL = 'null';
export const UNDEFINED = 'undefined';
